import instance from '../api';

const ContractsController = {
  async list(
    page: number = 1,
    status?: string,
    companyId?: string,
    type?: string,
    isDashcam?: boolean,
    companyContractStatus?: string,
  ) {
    try {
      let url = `contracts/admin/list?page=${page}&perPage=10`;
      if (companyId) {
        url += `&companyId=${companyId}`;
      }
      if (type) {
        url += `&type=${type}`;
      }
      if (isDashcam !== undefined) {
        url += `&isDashcam=${isDashcam}`;
      }
      if (status !== undefined) {
        url += `&status=${status}`;
      }
      if (companyContractStatus !== undefined) {
        url += `&companyContractStatus=${companyContractStatus}`;
      }

      const { data } = await instance(url);
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        console.error('Error:', error.response.data.error.message);
      }
    }
  },

  async find(contractID: string, includePendingCompanyContract?: boolean) {
    try {
      const { data } = await instance(`contracts/admin/find/${contractID}`, {
        params: {
          includePendingCompanyContract,
        },
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        console.error('Error:', error.response.data.error?.message || error.message);
      }
    }
  },

  async edit(contractId: string, payload: any) {
    try {
      const { data } = await instance.post(`/contracts/admin/edit/${contractId}`, payload);
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        console.error('Error:', error.response.data.error.message);
      }
      throw error;
    }
  },
  async create(companyId: string, payload: any) {
    try {
      const { data } = await instance.post(`/contracts/admin/create/${companyId}`, payload);
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        console.error('Error:', error.response.data.error.message);
      }
      throw error;
    }
  },
  async pricesList(contractId: string) {
    try {
      const { data } = await instance(`/contracts/admin/prices/${contractId}`);
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        console.error('Error:', error.response.data.error.message);
      }
      throw error;
    }
  },
  async createPricesList(companyId: string) {
    try {
      const { data } = await instance(`/contracts/admin/v2/prices/${companyId}`);
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        console.error('Error:', error.response.data.error.message);
      }
      throw error;
    }
  },
  async paymentMethod(contractId: string) {
    try {
      const { data } = await instance(`/contracts/admin/payment-methods/${contractId}`);
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        console.error('Error:', error.response.data.error.message);
      }
      throw error;
    }
  },
  async createPaymentMethod(companyId: string) {
    try {
      const { data } = await instance(`/contracts/admin/v2/payment-methods/${companyId}`);
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        console.error('Error:', error.response.data.error.message);
      }
      throw error;
    }
  },
  async uploadDocument(file: File) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const { data } = await instance.post('/contracts/admin/upload-document', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        console.error('Error:', error.response.data.error.message);
      }
      throw error;
    }
  },
  async updateStatus(contractId: string, payload: any) {
    try {
      const { data } = await instance.patch(
        `/contracts/admin/update-status/${contractId}`,
        payload,
      );
      return data;
    } catch (error: any) {
      console.error('Error:', error.response?.data?.error?.message || error.message);
      throw error;
    }
  },

  async deleteContract(contractId: string) {
    try {
      const { data } = await instance.delete(`/contracts/admin/delete/${contractId}`);
      return data;
    } catch (error: any) {
      console.error('Error:', error.response?.data?.error?.message || error.message);
      throw error;
    }
  },

  async createDashCamRequest(companyId: string, payload: any) {
    try {
      const { isStripe, ...body } = payload || {};
      const params = new URLSearchParams();
      if (isStripe !== undefined) {
        params.append('isStripe', String(isStripe));
      }
      const query = params.toString();
      const { data } = await instance.post(
        `/contracts/admin/create-for-dashcam/${companyId}${query ? `?${query}` : ''}`,
        body,
      );
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        console.error('Error:', error.response.data.error.message);
      }
      throw error;
    }
  },
  async editDashCamRequest(contractId: string, payload: any) {
    try {
      const { data } = await instance.patch(
        `/contracts/admin/edit-for-dashcam/${contractId}`,
        payload,
      );
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        console.error('Error:', error.response.data.error.message);
      }
      throw error;
    }
  },
  // Linked companies

  async editCompanyContract(contractId: string, payload: any) {
    try {
      const { data } = await instance.patch(`/companyContracts/admin/edit/${contractId}`, payload);
      return data;
    } catch (error: any) {
      if (error?.response?.status) {
        console.error('Error:', error.response?.data?.error?.message || error.message);
      }
      throw error;
    }
  },
};

export default ContractsController;
